<template>
  <pt-promotion-review class="pt-promotion-review__page"></pt-promotion-review>
</template>

<script>
import PtPromotionReview from 'cps/mall-manage/pt-promotion-review/withData'
export default {
  name: 'pt-promotion-review__view',
  components: {
    'pt-promotion-review': PtPromotionReview
  }
}
</script>
